<template>
  <div v-if="showBanner" class="cookie-banner d-none">
    <p>
      We use cookies on our website to give you the most relevant experience by
      remembering your preferences and repeat visits. By clicking "Accept All
      Cookies", you consent to the use of all the cookies. You can choose to
      manage your cookie settings or view our
      <a href="http://www.snipp.com/privacy-policy/" target="_blank"
        >Privacy Policy</a
      >.
    </p>
    <button @click="acceptCookies">Accept cookies</button>
    <button @click="rejectCookies">Reject</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showBanner: true,
    };
  },
  mounted() {
    this.checkCookieConsent();
  },
  methods: {
    setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = 'expires=' + date.toUTCString();
      document.cookie = name + '=' + value + ';' + expires + ';path=/';
    },
    getCookie(name) {
      const nameEQ = name + '=';
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    checkCookieConsent() {
      const consent = this.getCookie('cookieConsent');
      if (consent) {
        this.showBanner = false;
      }
    },
    acceptCookies() {
      this.setCookie('cookieConsent', 'accepted', 365);
      this.showBanner = false;
    },
    rejectCookies() {
      this.setCookie('cookieConsent', 'rejected', 365);
      this.showBanner = false;
    },
  },
};
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #fff;
  padding: 30px 20px;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cookie-banner p {
  margin: 0;
  font-size: 16px;
}
.cookie-banner a {
  text-decoration: underline;
  display: inline-block;
}
.cookie-banner button {
  margin-left: 10px;
  padding: 12px 6px;
  border: none;
  min-width: 185px;
  cursor: pointer;
}

.cookie-banner button:first-of-type {
  background-color: #253b48;
  color: #fff;
}

.cookie-banner button:last-of-type {
  background-color: #eee;
  color: #253b48;
  border: 1px solid #253b48;
}

@media screen and (max-width: 575px) {
  .cookie-banner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    align-content: center;
  }
  .cookie-banner button {
    margin: 10px;
  }
}
</style>
<!-- remove above code and add this below commented template for  cookie banner with preferences options -->
<!-- <template>
  <div v-if="showBanner" class="cookie-banner">
    <p>
      We use cookies on our website to give you the most relevant experience by
      remembering your preferences and repeat visits. By clicking "Accept All
      Cookies", you consent to the use of all the cookies. You can choose to
      manage your cookie settings or view our
      <a href="http://www.snipp.com/privacy-policy/" target="_blank"
        >Privacy Policy</a
      >.
    </p>
    <button @click="acceptCookies">Accept All Cookies</button>
    <button @click="showCookieSettings">Manage Settings</button>
  </div>
  <div v-if="showSettings" class="cookie-settings">
    <h3>Manage Cookie Preferences</h3>
    <label>
      <input type="checkbox" v-model="preferences.necessary" disabled />
      Necessary
    </label>
    <label>
      <input type="checkbox" v-model="preferences.analytics" /> Analytics
    </label>
    <label>
      <input type="checkbox" v-model="preferences.marketing" /> Marketing
    </label>
    <button @click="savePreferences">Save Preferences</button>
    <button @click="rejectCookies">Reject</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showBanner: true,
      showSettings: false,
      preferences: {
        necessary: true,
        analytics: false,
        marketing: false,
      },
    };
  },
  mounted() {
    this.checkCookieConsent();
  },
  methods: {
    setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = 'expires=' + date.toUTCString();
      document.cookie = name + '=' + value + ';' + expires + ';path=/';
    },
    getCookie(name) {
      const nameEQ = name + '=';
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    checkCookieConsent() {
      const consent = this.getCookie('cookieConsent');
      if (consent) {
        this.showBanner = false;
        this.preferences = JSON.parse(consent);
      }
    },
    acceptCookies() {
      const preferences = {
        necessary: true,
        analytics: true,
        marketing: true,
      };
      this.setCookie('cookieConsent', JSON.stringify(preferences), 365);
      this.showBanner = false;
    },
    rejectCookies() {
      const preferences = {
        necessary: true,
        analytics: false,
        marketing: false,
      };
      this.setCookie('cookieConsent', JSON.stringify(preferences), 365);
      this.showBanner = false;
      this.showSettings = false;
    },
    showCookieSettings() {
      this.showSettings = true;
    },
    savePreferences() {
      this.setCookie('cookieConsent', JSON.stringify(this.preferences), 365);
      this.showBanner = false;
      this.showSettings = false;
    },
  },
};
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #fff;
  padding: 30px 20px;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cookie-banner p {
  margin: 0;
  font-size: 16px;
}
.cookie-banner a {
  text-decoration: underline;
  display: inline-block;
}
.cookie-banner button {
  margin-left: 10px;
  padding: 12px 6px;
  border: none;
  min-width: 185px;
  cursor: pointer;
}

.cookie-banner button:first-of-type {
  background-color: #253b48;
  color: #fff;
}

.cookie-banner button:last-of-type {
  background-color: #eee;
  color: #253b48;
  border: 1px solid #253b48;
}

.cookie-settings {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #fff;
  padding: 20px;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.cookie-settings h3 {
  margin: 0 0 20px 0;
}

.cookie-settings label {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.cookie-settings input {
  margin-right: 10px;
}

.cookie-settings button {
  margin-top: 10px;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
}

.cookie-settings button:first-of-type {
  background-color: #253b48;
  color: #fff;
}

.cookie-settings button:last-of-type {
  background-color: #eee;
  color: #333;
}
@media screen and (max-width: 575px) {
  .cookie-banner{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    align-content: center;
  }
  .cookie-banner button {
    margin: 10px;
  }
}
</style> -->
